<script>
import {mapGetters} from "vuex";
import Loading from "@/components/Loading.vue";
import AnalyticsDetailRow from "@/components/MultiConnect/Analytics/AnalyticsDetailRow.vue";

export default {
  name: "PostAnalytics",
  components: {AnalyticsDetailRow, Loading},
  props: {
    isPdf: {
      type: Boolean,
      default: false,
    }
  },
  methods: {
    view(type) {
      this.$router.push({
        name: "postAnalytics",
        query: {
          type: type
        },
        params: {
          eventId: this.currentEvent.id,
        }
      });
    }
  },
  computed: {
    ...mapGetters(["currentEvent"]),
    postAnalytics() {
      return this.currentEvent.analyticsData.postsAnalytics;
    },
    getPostData() {
      return [
        {name: "General posts", value: this.postAnalytics.generalPosts, type: "general"},
        {name: "Announcement posts", value: this.postAnalytics.announcementPosts, type: "announcement"},
        {name: "Session content posts", value: this.postAnalytics.sessionPosts, type: "session"},
      ];
    }
  }
}
</script>

<template>
  <div>

  <v-card height="275" :outlined="isPdf ? false : true">
      <v-card-title class="pt-4 pb-2">Posts created within your event space</v-card-title>
      <!--      <div v-if="this.eventActivities === null || this.eventActivities === undefined">
              <Loading/>
            </div>-->
      <div>
        <v-card-subtitle class="d-flex justify-space-between align-center pt-0 pb-4">
          <div class="d-flex">
            <img
                :src="require(`@/assets/icons/post-add.${isPdf ? 'png' : 'svg'}`)"
                width="18"
                contain
                class="mr-2"
                style="stroke: #516077; color: #516077"
            />
            <span style="color: #202020">{{ this.currentEvent.analyticsData.totalPostCreated }} posts created</span>
          </div>
        </v-card-subtitle>
<!--        <v-divider/>-->
        <div v-for="item in getPostData" class="px-4">
          <AnalyticsDetailRow :title="item.name" :value="item.value" :show-view-button="true" @onView="view(item.type)"/>
          <v-divider/>
        </div>
      </div>

    </v-card>
  </div>
</template>

<style scoped>

</style>